import React from 'react';
import { VERSION_LABEL } from '../config/version';
export default function VersionBadge({ className = '' }) {
  return (
    <span className={`text-[11px] leading-none text-gray-400 select-none ${className}`} title={`Build ${VERSION_LABEL}`}>
      {VERSION_LABEL}
    </span>
  );
}
